import script from "./OmniBsDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./OmniBsDropdown.vue?vue&type=script&setup=true&lang=js"

import "./OmniBsDropdown.vue?vue&type=style&index=0&id=bf0042bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf0042bc"]])

export default __exports__